import styled from '@emotion/styled'


export const PageLayout = styled.div`
    position: relative;
    display: block;
    width: 100%;
    min-height: 100vh;
    overflow: auto;
    background-color: #0e0e0f;
`
